import { default as Base } from '../services/services.Utils.js';
import { default as Utils } from '../utils/base.Utils.js';

export default class Logout extends Base {

  constructor() {
    super();
  }

  static idpLogout(idpLogoutURL) {
    return super.doTheCall(null, { type: 'GET', url: idpLogoutURL, authenticated: false});
  }
  
  static casLogout(casLogoutURL) {
    return super.doTheCall(null, { type: 'GET', url: casLogoutURL, authenticated: false});
  }
 
}
